import Vue from 'vue'
import Main from './main.vue'
import { LEAVE_ROLE } from '@/utils/constUtils'
import { getItem } from '@/utils/comUtils'
const MConstructor = Vue.extend(Main) // 直接将Vue组件作为Vue.extend的参数

let MInstance = null
/**
 * 登录窗口
 * @param {object} options 配置
 */
const MSchoolPadList = options => {
  return new Promise((resolve, reject) => {
    if (typeof options !== 'object') {
      reject(new Error('参数错误'))
      return
    }
    let _options = {
      role: options.role, // 操作角色 家长：1  班主任：2  管理员：3
      corpName: options.corpName || '', // 钉钉机构名
      corpId: options.corpId || '', // 钉钉机构Id
      campus: options.campus || {}, // 初始校区列表(角色为管理员时有效)
      studentList: options.studentList || [], // 初始学生列表(角色为家长时必传)
      multiple: options.multiple === undefined ? true : options.multiple, // 是否多选  true：多选  false  单选
      selectType: options.selectType || 0, // 选择类型 0 所有层级都可以选 经典校区（1-学段 2-年级 3-班级 4-学生） 自定义校区（4-部门 3-班级 5-学生）
      returnType: options.returnType || 0, // 返回值类型
      defaultSelectedDepts: options.defaultSelectedDepts || [], // 默认选中部门节点列表（注意：类型必须和returnType设定一致）
      defaultSelectedMembers: options.defaultSelectedMembers || [], // 默认选中部门节点列表（注意：类型必须和returnType设定一致）
      disabledDeptIds: options.disabledDeptIds || [], // 不可选中部门节点Id列表（注意：returnType为none和node时，必须传魔点部门Id，为ding和dingNode时，必须传钉钉Id）
      disabledMemberIds: options.disabledMemberIds || [], // 不可选中部门节点Id列表（注意：returnType为none和node时，必须传魔点部门Id，为ding和dingNode时，必须传钉钉Id）
      needReturn: options.needReturn || false, // 返回是否返回tag
      title: options.title, // 要展示的弹框的title
      liveInOnly: options.liveInOnly || false,
      selectedDevices: options.selectedDevices || [], // 已选设备
      selectedDeptIds: options.selectedDeptIds || [], // 已选部门
      doubleBack: options.doubleBack || false, // 双层回退
      multipleMode: options.multipleMode || false,
      isHackedIos: options.isHackedIos || false // 是否需要兼容IOS回退问题
    }
    // 自定义校区 只能指定到人或者班级  经典校区可以指定到某个具体的层级
    if (
      Object.prototype.toString.call(options.campus) !== '[object Array]' &&
      options.campus &&
      options.selectType !== 5 &&
      options.selectType !== 0
    ) {
      _options.selectType = _options.selectType === 3 ? 3 : 5
    }
    // 老师大类下，只存在管理员与班主任两种角色
    if (_options.role && _options.role === LEAVE_ROLE.classTeacher) {
      let _roleIdList = getItem('roleIdList') || []
      // 角色优先级-管理员-班主任
      _options.role = [LEAVE_ROLE.admin, LEAVE_ROLE.headmaster].find(item =>
        _roleIdList.includes(item)
      )
    }
    // 单选时
    // if (!this.multiple) {
    //   delete _options.defaultSelectedDepts
    //   delete _options.defaultSelectedMembers
    // }
    // eslint-disable-next-line
    _options.close = function (result) {
      MSchoolPadList.close()
        .then(() => {
          resolve(result)
        })
        .catch(err => {
          reject(err)
        })
    }
    // eslint-disable-next-line
    _options.closeOnly = function () {
      MSchoolPadList.close()
        .then(res => {
          resolve({
            $type: this.needReturn ? 'onlyReturn' : ''
          })
        })
        .catch(err => {
          reject(err)
        })
    }
    MInstance = new MConstructor({
      data: _options
    })

    MInstance.vm = MInstance.$mount() // 挂载但是并未插入dom，是一个完整的Vue实例
    MInstance.dom = MInstance.vm.$el
    document.body.appendChild(MInstance.dom) // 将dom插入body
    MInstance.vm.visible = true
  })
}

// eslint-disable-next-line
MSchoolPadList.close = function () {
  return new Promise((resolve, reject) => {
    if (MInstance) {
      // //销毁vm实例与DOM之间的关联
      MInstance.vm.$destroy()
      window.history.go(-1)
      // 防止返回后通讯录一直盖在界面上没有消失
      let $addressDom = MInstance.dom
      $addressDom && $addressDom.remove()
      MInstance = null
    } else {
      let $addressDom = document.getElementById('$address-book$')
      $addressDom && $addressDom.remove()
    }
    resolve()
  })
}

export default MSchoolPadList
